import { Schema } from './lib/Schema';

export default Schema;
export { Schema };